import { useLocation, matchPath } from "react-router-dom";
import AddEditNoteSideSheet from "@/features/global/components/AddEditNoteSideSheet";
import { NoteNotableValues } from "@/types";
import useCurrentBackofficeUser from "@/hooks/useCurrentBackofficeUser";

type CreateGlobalNoteSideSheetProps = {
  sidebarOpen: boolean;
  setSidebarOpen: (value: boolean) => void;
};

export default function CreateGlobalNoteSideSheet({ sidebarOpen, setSidebarOpen }: CreateGlobalNoteSideSheetProps) {
  const { pathname } = useLocation();
  const personMatch = matchPath("/people/:pgaId/*", pathname);
  const pgaId = personMatch?.params.pgaId;

  const currentUser = useCurrentBackofficeUser();

  return (
    <AddEditNoteSideSheet
      open={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      currentUser={currentUser}
      showPersonSearch
      {...(pgaId
        ? {
            notableId: pgaId,
            notableType: NoteNotableValues.PERSON,
            pgaId,
            objectType: "person"
          }
        : {})}
    />
  );
}
